// The room this screen is in, or null for a match against the AI. Its own file,
// so the save and the views can ask about it with no loop of imports.

import { createStore } from '../lib/store';
import type { RoomView, SeatId } from '../room/protocol';
import type { SocketStatus } from '../room/roomSocket';

/**
 * `gone`: no room has the code. `old`: this page is an older build than the
 * server. `replaced`: the seat opened in another tab or on another device.
 */
export type RoomStatus = SocketStatus | 'gone' | 'old' | 'replaced';

export type RoomState = {
  code: string;
  status: RoomStatus;
  /** Null for a spectator, and before the welcome. */
  seat: SeatId | null;
  /** Null before the first word from the server. */
  view: RoomView | null;
  /** True after a vote for a rematch from this screen, until the room goes back to the picks. */
  votedRematch: boolean;
};

export const roomStore = createStore<RoomState | null>(null);

export const isInRoom = (): boolean => roomStore.get() !== null;

export const updateRoom = (change: Partial<RoomState>): void =>
  roomStore.set((room) => (room ? { ...room, ...change } : room));
